// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bubbles{
    position: relative;
    /*border: 1px solid #000;*/
    overflow: hidden;
    width: 100%;
    height: 280px;
}

.bubble{
    position: absolute;
    background-color: #E23424;
    /*border: 1px solid #000;*/
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 100%;
    font-size: 8px;
    line-height: 1;
    cursor: pointer;
    z-index: 1;
    pointer-events: auto;
}

.bubble:hover{
    box-shadow: 0px 0px 2px #ffff, 0px 0px 9px #0005;
}

.bubble_text{
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/bubbles/Bubbles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,eAAe;IACf,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".bubbles{\n    position: relative;\n    /*border: 1px solid #000;*/\n    overflow: hidden;\n    width: 100%;\n    height: 280px;\n}\n\n.bubble{\n    position: absolute;\n    background-color: #E23424;\n    /*border: 1px solid #000;*/\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border-radius: 100%;\n    font-size: 8px;\n    line-height: 1;\n    cursor: pointer;\n    z-index: 1;\n    pointer-events: auto;\n}\n\n.bubble:hover{\n    box-shadow: 0px 0px 2px #ffff, 0px 0px 9px #0005;\n}\n\n.bubble_text{\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
